<template>
  <div class="trainee-list-modal-overlay">
        <transition name="modal-expand">
        <div v-if="isVisible" class="trainee-list-modal" @click.stop>
      <div class="modal-content">
        <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
        <h2>Edit Task ID: {{ newTask.task_id }}</h2>

        <div class="add">
          <form @submit.prevent="updateTask">

            <div class="form-group">
              <label for="name">Reference:</label>
              <input type="text" class="form-control rounded" id="name" name="name" placeholder="Enter Task Reference"
                v-model="newTask.reference" />
            </div>
            <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
              <div v-if="errorMessage">{{ errorMessage }}</div>
            </div>
            <div>
              <button class="btn btn-primary rounded" type="submit">Update Task</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>
  
<script>
import axios from 'axios';

export default {
  data() {
    return {
      tasks: [],
      newTask: {
        reference: '',
      },
      showAlert: false,
      errorMessage: '',
      processing: false,
      isVisible: false,
    };
  },
  methods: {

    async updateTask() {
      try {
        const task_id = localStorage.getItem('task_id');
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const response = await axios.put(
          `/api/tasks/${task_id}`,
          {
            reference: this.newTask.reference,
          },
          { headers }
        );

        console.log('update')
        console.log(response);

        if (response.status === 200) {
          window.alert('Task updated Successfully');
          this.newTask = {
            reference: '',
          };
          this.errorMessage = '';
          this.showAlert = false;
        }
        window.location.reload();

      } catch (error) {
        console.error('Error updating task:', error);


        if (error.response && error.response.data && error.response.data.errors) {
          // Handle validation errors
          const validationErrors = error.response.data.errors;

          // Build an error message from the validation errors
          let errorMessage = 'Validation errors:';
          for (const field in validationErrors) {
            errorMessage += `\n${field}: ${validationErrors[field][0]}`;
          }

          this.errorMessage = errorMessage;
        } else {
          // Handle other errors
          this.errorMessage = 'An error occurred while updating the Task.';
        }

        this.showAlert = true;
      }
    },
    close() {
      this.$emit('close'); // Emit an event to indicate the modal should be closed
    },
    getTaskData(task_id) {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        axios.get(`/api/tasks/${task_id}`, { headers })
          .then(res => {
            this.newTask = res.data;
            console.log(res.data);
          });
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    },
  },
  async mounted() {
    this.isVisible = true;
    this.getTaskData(localStorage.getItem('task_id'));

  },
}
</script>
  
<style scoped>
.trainee-list-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Ensure the modal is on top of other content */
}

h2 {
  margin-top: 30px;
  font-size: 30px;
  margin-bottom: 30px;
}

/* Style your modal content */
.trainee-list-modal {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  width: 80%;
  max-width: 1000px;
  /* Limit the maximum width of the modal */
  padding: 20px;
  position: relative;
  max-height: 95%;

}


.modal-content {
  overflow-y: auto;
  /* Enable scrolling within the modal content */
}


.add button {
  width: 200px;
  height: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid rgb(0, 96, 134);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

h2 {
    margin-top: 10px;
    font-size: 30px;
    margin-bottom: 40px;
}

.form-control.rounded {
    height: 40px;
}

.form-group {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
}

.form-group label {
    width: 120px;
    margin-right: 50px;
    text-align: right;
    margin-bottom: 0px;
}

.form-group input.form-control,
.form-group select.form-control {
    flex: 1;
    width: auto;
    margin-left: 0;
    margin-bottom: 0px;
}

h1 {
  margin-bottom: 20px;
}

.alert-danger {
    color: #ff0019;
    background-color: #f8d7da;
    border: 1px solid #e6b0b6;
}

.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 0rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}
</style>
  